import { cx, type PidBaseProps } from './shared'

export interface AnalogIndicatorProps extends PidBaseProps {
  value: number
  unit?: string
  digits?: number
  /** Optional 0–1 fraction for the spark bar under the value. */
  fraction?: number
  status?: 'ok' | 'warn' | 'alarm'
}

export function AnalogIndicator({
  value,
  unit = '',
  digits = 1,
  fraction,
  status = 'ok',
  tag,
  className,
  style,
  title
}: AnalogIndicatorProps) {
  const bar = fraction !== undefined ? Math.max(0, Math.min(1, fraction)) : undefined

  return (
    <div
      className={cx('pid-indicator', status !== 'ok' && `pid-indicator-${status}`, className)}
      style={style}
      title={title ?? tag}
    >
      <div className="pid-indicator-row">
        <span className="pid-readout-value">{value.toFixed(digits)}</span>
        {unit ? <span className="pid-readout-unit">{unit}</span> : null}
      </div>
      {bar !== undefined && (
        <div className="pid-indicator-bar" aria-hidden>
          <div className="pid-indicator-bar-fill" style={{ width: `${bar * 100}%` }} />
        </div>
      )}
    </div>
  )
}
